<template>
    <svg
        height="24px"
        width="24px"
        id="grid"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 28"
        style="fill: currentColor"
    >
        <path
            id="Tracé_8"
            data-name="Tracé 8"
            d="M10.512,0H1.168C.523,0,0,.365,0,.818V7.358c0,.452.523.818,1.168.818h9.344c.645,0,1.168-.365,1.168-.818V.818C11.68.365,11.156,0,10.512,0Z"
        />
        <path
            id="Tracé_9"
            data-name="Tracé 9"
            d="M24.512,0H15.168C14.523,0,14,.731,14,1.635V14.716c0,.9.523,1.635,1.168,1.635h9.344c.645,0,1.168-.731,1.168-1.635V1.635C25.68.731,25.156,0,24.512,0Z"
            transform="translate(2.32)"
        />
        <path
            id="Tracé_10"
            data-name="Tracé 10"
            d="M10.512,14H1.168C.523,14,0,14.731,0,15.635V28.716c0,.9.523,1.635,1.168,1.635h9.344c.645,0,1.168-.731,1.168-1.635V15.635C11.68,14.731,11.156,14,10.512,14Z"
            transform="translate(0 -2.351)"
        />
        <path
            id="Tracé_11"
            data-name="Tracé 11"
            d="M24.512,14H15.168c-.645,0-1.168.365-1.168.818v6.541c0,.452.523.818,1.168.818h9.344c.645,0,1.168-.365,1.168-.818V14.818C25.68,14.365,25.156,14,24.512,14Z"
            transform="translate(2.32 5.824)"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-dashboard",
});
</script>
